import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';

import './App.css';
import { BrowserRouter as Router } from 'react-router-dom';

import axios from './utils/axios';
// import axios from "axios";

import { useDispatch, useSelector } from 'react-redux';

import { dispatchSignIn, fetchUser } from './redux/actions/userActions';
import { getProspects } from './redux/actions/prospectActions';

// Components testing
// import Signin from "./Pages/Signin";
import Pages from './Pages';
import Skeleton from './Components/Skeletons/ProspectSkeletons';
import { useResponsiveDetector } from './hooks/useResponsiveDetector';

function App() {
  // axios.defaults.withCredentials = true;
  useResponsiveDetector();

  const [loading, setLoading] = useState(true);

  const dispatch = useDispatch();
  const auth = useSelector((state) => state.user);
  const token = useSelector((state) => state.token);

  useEffect(() => {
    const firstSignin = localStorage.getItem('firstSignin');
    if (firstSignin) {
      const getToken = async () => {
        try {
          const refreshtoken = Cookies.get('refreshtoken');

          const res = await axios.post('/api/user/refresh_token', {
            refreshtoken: refreshtoken,
          });

          dispatch({ type: 'GET_TOKEN', payload: res.data.access_token });
        } catch (error) {
          console.log(error);
        }
      };
      getToken();
    }
    setLoading(false);
  }, [auth.isSignedIn, dispatch]);

  useEffect(() => {
    if (token) {
      const getUser = () => {
        dispatch(dispatchSignIn());
        dispatch(fetchUser(token));

        axios.interceptors.request.use(
          (config) => {
            config.headers['Authorization'] = token;
            return config;
          },
          (error) => {
            return Promise.reject(error);
          },
        );
        dispatch(getProspects());
      };
      getUser();
    }
  }, [token]);

  return <Router>{loading ? <Skeleton /> : <Pages />}</Router>;
}

export default React.memo(App);
